import React, { useCallback } from 'react';
import { MAX_BRANCH_LEVEL } from './constants';
import './branch.scss';

const STAT_KEYS = [
  "LVL",
  "HP",
  "ATK",
  "DEF",
  "HP%",
  "ATK%",
  "DEF%",
  "MSPD",
  "DODGE",
  "CRIT",
  "LL",
  "ACC",
  "SKILL1",
  "SKILL2",
  "SKILL3",
  "COST",
  "SUM",
];

export default ({
  branch,
  stats,
  juiceLeft,
  setJuiceLeft,
  level,
  setLevel,
  treeLevel,
}) => {
  const maxLevel = Math.max(Math.min(treeLevel-10, MAX_BRANCH_LEVEL), 0)
  const clampLevel = useCallback((newLevel) => {
    newLevel = newLevel ? parseInt(newLevel) : 0;
    if (newLevel < 0) newLevel = 0;
    if (newLevel > maxLevel) newLevel = maxLevel;
    while (parseInt(stats[level].SUM) - parseInt(stats[newLevel].SUM) + juiceLeft < 0) newLevel--;
    const difference = parseInt(stats[level].SUM) - parseInt(stats[newLevel].SUM);
    setJuiceLeft(juiceLeft + difference);
    setLevel(newLevel);
  },[stats, juiceLeft, level, setLevel, setJuiceLeft, maxLevel]);

  const updateLevel = useCallback(
    ({ target: { value: newLevel } }) => {
      clampLevel(newLevel);
    },
    [clampLevel]
  );
  return (
    <div id="branch">
      <span>
        Branch: <span id="branch-name">{branch}</span>
      </span>
      <span id="level-controls">
        <span id="level-input">
          Level:
          <input
            id="level"
            value={level}
            onChange={updateLevel}
            type="number"
            min="0"
            max={maxLevel}
            inputMode="numeric"
            pattern="[0-9]*"
          />
        </span>
        <span id="level-buttons">
          <button disabled={parseInt(level) <= 4} onClick={() => clampLevel(parseInt(level)-5)}>-5</button>
          <button disabled={parseInt(level) <= 0} onClick={() => clampLevel(parseInt(level)-1)}>-1</button>
          <button disabled={parseInt(level) >= maxLevel || parseInt(stats[parseInt(level)+1].COST) > juiceLeft} onClick={() => clampLevel(parseInt(level)+1)}>+1</button>
          <button disabled={parseInt(level) >= maxLevel-4 || parseInt(stats[parseInt(level)+5].COST) > juiceLeft} onClick={() => clampLevel(parseInt(level)+5)}>+5</button>
        </span>
      </span>
      {STAT_KEYS.map(key => stats[level][key] !== undefined && (
        <span key={key}>
          {key}: {stats[level][key]}
          {level < MAX_BRANCH_LEVEL &&
            stats[level][key] !== stats[parseInt(level) + 1][key] && (
              <span className="next-level">
                {stats[parseInt(level) + 1][key]}
                {!key.startsWith("SKILL") && <span className="delta">
                  (+{
                    (stats[parseInt(level) + 1][key] - stats[parseInt(level)][key])
                    .toFixed(1)
                    .replace('.0', '')
                  })
                </span>}
              </span>
            )}
        </span>
      ))}
      {level < MAX_BRANCH_LEVEL && (
        <span>Next Level: {stats[parseInt(level) + 1].COST}</span>
      )}
    </div>
  );
};